import uid from 'customer-flows/utils/uid'

export function buildDemoOrder({
  quoteStore,
  activityStore,
  programStore,
  customerStore
}: {
  quoteStore: QuoteStore
  activityStore: ActivityStore
  programStore: ProgramStore
  customerStore: CustomerStore
}): Order {
  const id = uid(false)
  const orderId = `demo-${id}`

  const booking: Booking = {
    __typename: 'Booking',
    id: orderId,
    reservationStatus: 'CONFIRMED',
    activitySnapshot: {
      id: activityStore.id,
      name: activityStore.name
    }
  }

  return {
    id: orderId,
    displayId: `DEMO-${id.slice(0, 6).toUpperCase()}`,
    currency: (programStore.provider?.currency ?? 'USD') as Currency,
    hasOpenDisputes: false,
    balance: quoteStore.priceBreakdown ?? {},
    customer: {
      name: customerStore.name,
      email: customerStore.email,
      phone: customerStore.phone
    },
    provider: programStore.provider as Provider,
    sales: [booking]
  }
}
